export default __webpack_public_path__ + "static/media/icon_mision.1034d297.svg";